export default __webpack_public_path__ + "static/media/car-profile.8cde6d4c.svg";